import Spinner from '@acri-tools/react-tools/components/Spinner/Spinner';
import { axiosErrorHandler, toast_request_error } from '@acri-tools/react-tools/utils/global';
import { API_URL } from '../../utils/config';
import request from '@acri-tools/react-tools/utils/request';
import { create_toast } from '@acri-tools/react-tools/utils/toasts';
import React,{ Component } from 'react';
import { check_request, format_request_data } from '../../utils/requests';
import RequestForm from '../RequestForm/RequestForm';

import './UpdateRequest.css';

interface Props{
    request: any
    onUpdate: (update:any)=>void
}
interface State{
    entity?: any

    updating: boolean
}

export default class UpdateRequest extends Component<Props,State>{
    constructor(props:Props){
        super(props);
        this.state = {
            entity: props.request ? this.format_entity({ ...props.request }) : undefined,
            updating: false
        }
    }

    componentDidUpdate(prevProps:Props){
        if(this.props.request !== prevProps.request){
            this.setState({
                entity: this.props.request ? this.format_entity({ ...this.props.request }) : undefined,
                updating: false
            })
        }
    }

    format_entity = (entity:any) =>{
        [ 'product_type', 'filters', 'additional_requirements', 'target_products', 'period', 'aoi' ].forEach((attribute: string)=>{
            if(!(attribute in entity && entity[attribute] !== null)){
                entity[attribute] = [];
            }
        });
        return entity;
    }

    


    update = async() =>{
        try{
            check_request(this.state.entity);
        }
        catch(e:any){
            create_toast({ type: e.type === 'warning' ? 'warning' : 'error', message: e.message })
        }

        if(window.confirm(`Are you sure you want to update request '${this.state.entity.name}' ?`)){
            
            this.setState({ updating:true });
            try{
                let { entity } = this.state;
                let { id } = entity;
                format_request_data(entity);
                delete entity.id;
                let res = await request(`${API_URL}/api/v1/requests/${id}`,{
                    method:'put',
                    data: entity,
                })
                await this.setState({ 
                    entity: res.data.value,
                });
                create_toast({ type: 'success', message: res.data.message })
                this.props.onUpdate?.(res.data.value)
            }
            catch(e:any){
                axiosErrorHandler( e, { 
                    functionName: 'update', 
                    requestName: 'update_requests',
                })
                toast_request_error(e);
            }
            finally{
                this.setState({ updating:false });

            }
        }
    }
    
    render(){
        return (
            <>
                <RequestForm
                    request={this.state.entity}
                    onChange={(updates:any)=>{
                        this.setState({
                            entity: {
                                ...this.state.entity,
                                ...updates
                            }
                        })
                    }}
                />
                <br/>
                <br/>                
                {
                    this.state.updating ?
                        <div className="custom-button disabled inverted alt">
                            <Spinner white height={12}/> UPDATING REQUEST
                        </div>
                    :
                        <div className="custom-button green inverted alt" onClick={this.update}>
                            <i className="fas fa-pen"/> UPDATE REQUEST
                        </div>
                }
            </>
        );
    }
};